import { render, staticRenderFns } from "./SalesLayout.vue?vue&type=template&id=78839bb2&scoped=true"
import script from "./SalesLayout.vue?vue&type=script&lang=js"
export * from "./SalesLayout.vue?vue&type=script&lang=js"
import style0 from "./SalesLayout.vue?vue&type=style&index=0&id=78839bb2&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "78839bb2",
  null
  
)

export default component.exports